
import { useToast } from '@/hooks/use-toast'

/**
 * ToastContainer Component
 *
 * Renders all active toasts in a fixed top-right container.
 * Handles styling variants and dismiss interactions.
 */
export function ToastContainer() {
  const { toasts, dismiss } = useToast()

  return (
    <div className="fixed top-4 right-4 z-50 flex flex-col gap-2">
      {toasts.map(({ id, title, description, variant = 'default' }) => (
        <div
          key={id}
          className={`bg-white dark:bg-gray-800 shadow-lg rounded-lg p-4 flex items-center justify-between ${
            variant === 'success' ? 'border-l-4 border-green-500' :
            variant === 'error' ? 'border-l-4 border-red-500' :
            variant === 'warning' ? 'border-l-4 border-yellow-500' :
            variant === 'info' ? 'border-l-4 border-blue-500' : ''
          }`}
        >
          <div className="flex-1">
            {title && (
              <h4 className="font-medium text-gray-900 dark:text-gray-100">{title}</h4>
            )}
            {description && (
              <p className="text-sm text-gray-600 dark:text-gray-300">{description}</p>
            )}
          </div>

          <button
            onClick={() => dismiss(id)}
            className="ml-4 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
            aria-label="Dismiss toast"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  )
}
